import React from 'react';
import { Box } from '@mui/material';
import { Region } from 'shared-components/enums';

const REACT_APP_REGION = import.meta.env.REACT_APP_REGION;

interface Props {
  children?: React.ReactNode;
  isClinex?: boolean;
}

const ROSidePanel = ({ children, isClinex }: Props): JSX.Element => {
  const isInUK = REACT_APP_REGION === Region.UK;

  return (
    <Box
      data-testid="ro-side-panel"
      className={isClinex ? 'ro-side-panel clinex' : 'ro-side-panel'}
      sx={(theme) => ({
        marginLeft: 'auto',
        width: 320,
        minWidth: 320,
        height: '100%',
        padding: '15px 15px 60px',
        borderLeft: `1px solid ${theme.palette.grey[300]}`,
        overflow: 'auto',
        msOverflowStyle: 'none',
        backgroundColor: theme.palette.common.white,
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        [theme.breakpoints.down('lg')]: {
          width: 250,
          minWidth: 250,
        },
        ...(isInUK && {
          top: 122,
          minHeight: 'calc(100vh - 130px)',
        }),
        ...(isClinex && {
          maxHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          minWidth: 800,
          width: 'auto',
          padding: '0 12px',
        }),
      })}>
      {children}
    </Box>
  );
};

export default ROSidePanel;
